export default {
    data: {},
}
